// Routes des interventions (lot L3-A), raccordées dans Application.tsx par une seule ligne. Les
// chemins fixes précèdent la fiche /interventions/:id.
import type { RouteObject } from 'react-router';
import { PageConflits } from './PageConflits';
import { PageEquipes } from './PageEquipes';
import { PageIntervention } from './PageIntervention';
import { PageInterventions } from './PageInterventions';
import { PageSignalement } from './PageSignalement';
import { PageSignalements } from './PageSignalements';

export const routesInterventions: RouteObject[] = [
  { path: '/interventions', element: <PageInterventions /> },
  { path: '/interventions/signalements', element: <PageSignalements /> },
  { path: '/interventions/signalements/:id', element: <PageSignalement /> },
  { path: '/interventions/equipes', element: <PageEquipes /> },
  { path: '/interventions/conflits', element: <PageConflits /> },
  { path: '/interventions/:id', element: <PageIntervention /> },
];
